import { createSlice, configureStore } from "@reduxjs/toolkit";

export const appSlice = createSlice({
  name: "app",
  initialState: {
    hoveredProject: null,
    device: "desktop",
  },
  reducers: {
    setHoveredProject: (state, action) => {
      state.hoveredProject = action.payload;
    },
    setDevice: (state, action) => {
      state.device = action.payload;
    },
  },
});

export const { setHoveredProject, setDevice } = appSlice.actions;

export const selectHoveredProject = (state) => state.app.hoveredProject;
export const selectDevice = (state) => state.app.device;

export default configureStore({
  reducer: {
    app: appSlice.reducer,
  },
});
